module.exports = __webpack_public_path__ + "png/cards3.png?47831b8f144dc5e43f4b92c51b683887";